import { gql } from '@apollo/client/core'

export const categoryFragment = gql`
  fragment CategoryProps on Category {
    id
    name
    key
  }
`
